<template>
  <WsRead
    :modelName="modelName"
    :modelVersionName="`${modelName}_version`"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    :parentIsBelongsToMany="true"
    :belongsToChapters="false"
    :modelIdName="modelIdName"
    titleKey="last_version.name"
    :customBtns="_customBtns"
  >
  </WsRead>
</template>

<script>
import model from "@/models/risk_template";
// import submodel from "@/models/modify_risk_question";
export default {
  data: () => ({
    modelName: model.modelName,
    // submodelName: submodel.modelName,
    modelIdName: "risk_template_question_id",
    label: model.label,
    localeMode: true,
    modeVersions: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "風險評估資訊",
              fields: ["last_version.locales.name"],
              hideLabelFields: [],
            },
          ],
        },
        // {
        //   type: "expandList",
        //   label: submodel.label,
        //   modelName: "cklist_ques_tmp_ver",
        //   modelTemplateName: submodel.modelName,
        //   modeParent: true,
        //   modeParentVersions: true,
        //   fields: submodel.fields,
        //   titleKey: "title",
        //   fieldsRead: submodel.fieldsRead,
        //   searchMode: false,
        // },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: ["area", "area_section", "system_class", "system_subclass"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        // {
        //   type: "activeSwitch",
        //   title: "啟用",
        //   remark: "隱藏的內容將不會顯示於前端",
        //   field: "is_active",
        // },
      ],
    },
  }),
  computed: {
    _customBtns() {
      return [
        {
          // title: `更新${this.label}版本`,
          title: `更新風險評估版本`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          to: `/${this.modelName}/${this.$route.params.id}/version/update`,
        },
      ];
    },
  },
};
</script>